import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "./FontAwesomeIcon";
import classnames from "classnames";
import "./new-dora-inputs.scss";
import { useCallback, useLayoutEffect, useRef, } from "react";
const autoResizeHandler = (e) => {
    const el = e.currentTarget;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
};
const NUMERIC_CHARS = /^[-,.\d\s]*$/;
const NON_INPUT_KEYS = new Set([
    "Backspace",
    "Delete",
    "Tab",
    "Escape",
    "Enter",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
    "Home",
    "End",
]);
const numberOnlyKeyDownHandler = (e) => {
    if (e.ctrlKey || e.metaKey || e.altKey || NON_INPUT_KEYS.has(e.key)) {
        return;
    }
    if (!NUMERIC_CHARS.test(e.key)) {
        e.preventDefault();
    }
};
const numberOnlyPasteHandler = (e) => {
    const pasted = e.clipboardData.getData("text");
    if (!NUMERIC_CHARS.test(pasted)) {
        e.preventDefault();
    }
};
const DoraTextInput = (props) => {
    const { id, icon, placeholder, className, onChange, disabled, error, register, autoFocus, autoResize, numberOnly, ...rest } = props;
    const wrapperClasses = classnames("dora-text-input-wrapper", disabled ? "dora-text-input-wrapper--disabled" : null, error ? "dora-text-input-wrapper--error" : null, className);
    const classes = classnames("dora-text-input__input", {
        "dora-text-input__input--with-icon": !!icon,
    });
    const onChangeProp = !register
        ? {
            onChange: (e) => onChange && onChange(e.target.value),
        }
        : {};
    const sharedProps = {
        ...(id && { id }),
        ...register,
        ...onChangeProp,
        ...(autoFocus && { autoFocus: true }),
        ...rest,
        "aria-invalid": error ? "true" : "false",
        className: classes,
        disabled,
        placeholder,
    };
    const localRef = useRef(null);
    const { ref: registerRef } = register || {};
    const composedRef = useCallback((el) => {
        localRef.current =
            el;
        if (registerRef)
            registerRef(el);
    }, [registerRef]);
    useLayoutEffect(() => {
        if (autoResize && localRef.current) {
            const el = localRef.current;
            el.style.height = "auto";
            el.style.height = `${el.scrollHeight}px`;
        }
    });
    return (_jsxs("div", { className: wrapperClasses, children: [icon && (_jsx("div", { className: "dora-text-input__icon", children: _jsx(FontAwesomeIcon, { icon: icon }) })), autoResize ? (_jsx("textarea", { ...sharedProps, autoComplete: "on", ref: composedRef, rows: 1, onInput: autoResizeHandler })) : (_jsx("input", { ...sharedProps, type: "text", ...(numberOnly && {
                    onKeyDown: numberOnlyKeyDownHandler,
                    onPaste: numberOnlyPasteHandler,
                }) }))] }));
};
const UFDoraTextInput = (props) => {
    const { register, ...rest } = props;
    return _jsx(DoraTextInput, { register: register, ...rest });
};
export { DoraTextInput, UFDoraTextInput };
//# sourceMappingURL=DoraTextInput.js.map